/**
 * @typedef ContractTypes
 * @property {'saas'} SAAS SAAS модель (Платформа)
 * @property {'services'} SERVICES Услуги (Платформа PRO)
 * @property {'processing'} PROCESSING Процессинг (Платформа +)
 */

/** @type {Readonly<ContractTypes>} */
const contractTypes = {
  SAAS: 'saas', // SAAS модель (Платформа)
  SERVICES: 'services', // Услуги (Платформа PRO)
  PROCESSING: 'processing', // Процессинг (Платформа +)
};

module.exports = contractTypes;
